import React from 'react';

import { Box, Link } from '@opendoor/bricks-next';

import { OpendoorLogo, OpendoorLogoBadge } from 'components/landing-pages-v2/shared/OpendoorLogo';

export const LogoSection: React.FC = () => {
  return (
    <Box
      gridColumn="1 / 2"
      gridRow="1 / 2"
      pr="$4x"
      display="flex"
      flexDirection="row"
      alignItems="center"
      zIndex={5}
    >
      <Link
        color="$contentPrimary"
        href="/"
        analyticsName="cosmos-logo-link"
        aria-label="Go to Home page"
        $smallerThanMD={{ display: 'none' }}
      >
        <OpendoorLogo width="96px" />
      </Link>
      <Link
        color="$contentPrimary"
        href="/"
        analyticsName="cosmos-logo-link"
        aria-label="Go to Home page"
        $largerThanSM={{ display: 'none' }}
      >
        <OpendoorLogoBadge />
      </Link>
    </Box>
  );
};
